import React from 'react'
import { connect } from 'react-redux'
import Header from '../components/Header'
import CallToActionBar from '../components/CallToActionBar'
import { useParams } from 'react-router-dom'
import List from '../components/List'
import Search from '../components/Search'
import { fetchKnowledgeBases } from '../actions/knowledgeBaseActions'

const getNode = (nodeId, knowledgeBaseFlatList) => {
  return (
    knowledgeBaseFlatList &&
    knowledgeBaseFlatList.find(
      knowledgeBase => knowledgeBase.nodeId === parseInt(nodeId)
    )
  )
}

const getChildren = (nodeId, knowledgeBaseFlatList) => {
  return (
    knowledgeBaseFlatList &&
    knowledgeBaseFlatList.filter(
      knowledgeBase => knowledgeBase.parentId === parseInt(nodeId)
    )
  )
}

const Detail = ({ knowledgeBaseFlatList, brand }) => {
  const { nodeId } = useParams()

  const node = getNode(nodeId, knowledgeBaseFlatList)

  const parent =
    node && node.parentId ? getNode(node.parentId, knowledgeBaseFlatList) : null

  const children = getChildren(nodeId, knowledgeBaseFlatList)

  return (
    <>
      <Header nodes={[parent, node]} />
      <div className="container">
      {!node && <div className="loading" />}
      {node && (
        <div className="block-section detail">
          {!parent &&
            children &&
            children.map(child => (
              <div key={child.nodeId}>
                <h2>{child.displayText}</h2>
                <List
                  items={getChildren(child.nodeId, knowledgeBaseFlatList)}
                  brand={brand}
                />
              </div>
            ))}
          {parent && children && (
            <div>
              <h2 className="text-left">{node.displayText}</h2>
              <List items={children} brand={brand} />
            </div>
          )}
        </div>
      )}
      </div>
      <Search title={'Antwoord niet gevonden?'} brand={brand} />
      <CallToActionBar brand={brand} />
    </>
  )
}

const mapStateToProps = state => ({
  knowledgeBaseFaq: state.knowledgeBase.knowledgeBaseFaq,
  knowledgeBaseTree: state.knowledgeBase.knowledgeBaseTree,
  knowledgeBaseFlatList: state.knowledgeBase.knowledgeBaseFlatList,
  loading: state.knowledgeBase.loading
})
const mapDispatchToProps = dispatch => ({
  fetchKnowledgeBases: brand => dispatch(fetchKnowledgeBases(brand))
})

export default connect(mapStateToProps, mapDispatchToProps)(Detail)
